/**
 * Housekeeping on one conversation (ruling R-0828-1).
 *
 * DELIBERATELY NOT IN `inbox.ts`. The shapes there are the recipient's five
 * decision verbs, and these two are neither decisions nor recipient-only: an
 * owner archives the knocks they SENT on exactly the same terms as the ones that
 * arrived. Which side the viewer is on is never sent — the server resolves it
 * from the knock, because a client-supplied side is a client-supplied claim
 * about whose copy is being deleted.
 */
import { z } from "zod";

/** Put a conversation away, or bring it back. One shape, because it is one write. */
export const ConversationArchiveRequest = z.object({
  knock_id: z.uuid(),
  archived: z.boolean(),
});
export type ConversationArchiveRequest = z.infer<typeof ConversationArchiveRequest>;

/**
 * Delete the viewer's own copy. There is no `deleted: false` — the mark is
 * irreversible by design, and a boolean would advertise an undo that does not
 * exist.
 */
export const ConversationDeleteRequest = z.object({
  knock_id: z.uuid(),
});
export type ConversationDeleteRequest = z.infer<typeof ConversationDeleteRequest>;
